module.exports = {
      id: "sek-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#sek-usage",
      toString: function () {
        return this.url;
      }
    }